import React, { useState, useEffect } from 'react';
import { SubNav } from '../../layout/submenu';
import { usePermission } from '../../../helpers/common';

const ActionInput = (props) => {
    const { isChecked, cntrlId, actionId, updatePermission } = props;

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked]);

    const handleOnChange = (e) => {
        setChecked(e.target.checked);

        const params = {
            action_id: parseInt(actionId),
            controller_id: parseInt(cntrlId),
            enable: e.target.checked
        };

        updatePermission(params, (isSuccess) => !isSuccess && setChecked(isChecked));
    };

    const allow = usePermission();
    const isAllowCreate = allow("user", "create") ? true : false;
    const isAllowEdit = allow("user", "edit") ? true : false;

    return <SubNav.Checkbox
        checked={checked}
        className={`${!(isAllowCreate || isAllowEdit) && "disable"}`}
        onChange={(isAllowCreate || isAllowEdit) ? handleOnChange : () => { }} />
}

export default ActionInput;